import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-659c13a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap_screen" }
const _hoisted_2 = { class: "status_bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 받은 문의 ", -1))
const _hoisted_4 = { class: "wrap_right_layout" }
const _hoisted_5 = { class: "wrap_table" }
const _hoisted_6 = { style: {"table-layout":"fixed"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px"} }, " 번호 "),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, " 이름 "),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"200px","text-align":"left"} }, " 이메일 "),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"600px","text-align":"left"} }, " 내용 "),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px"} }, " 삭제 ")
], -1))
const _hoisted_8 = { style: {"width":"50px"} }
const _hoisted_9 = { style: {"width":"100px"} }
const _hoisted_10 = { style: {"width":"200px","text-align":"left"} }
const _hoisted_11 = { style: {"width":"600px","text-align":"left"} }
const _hoisted_12 = { class: "delete" }
const _hoisted_13 = ["onClick"]

import {
  ref,
  onMounted,
  onUnmounted,
  computed,
} from 'vue';
import { notification as AntNotification } from 'ant-design-vue/lib/components';
import type { SelectProps } from 'ant-design-vue';
import { Modal } from 'ant-design-vue';
import {
  iAvatar,
  iUserRoom,
} from '@interface/chat';
import {
  tabStore,
  userStore,
  tutorialStore,
} from '../stores/storeAuth';
import { pushPage } from '@utils/route.helper';
import { routeHelper } from '@utils';
import router from '@router';
import { errorType } from '@interface/error';
import {
  postAvatar,
  requestGetAvatarList,
  getAvatarDetail,
  deleteBoard,
  getBoardList,
} from '@apis/voicechat';


export default /*#__PURE__*/_defineComponent({
  __name: 'AskBoard',
  setup(__props) {

const { pushQueryPage } = routeHelper;
const tabData = tabStore();
const showMobileMenu = () => {
  tabData.sideMenu = true;
};

// 공지 리스트 조회 table
const boardList = ref<any[]>([]);
const getList = async () => {
  try {
    const result = await getBoardList();
    console.log(result.data, 'asdasdjlkasjdlkasjdlksajd');
    boardList.value = result.data.boards;

    // meta.value = result.data.data.meta;
  } catch (error) {
    AntNotification.error({ message: error?.message });
  }
};

const deleteAsk = (id: number) => {
  Modal.confirm({
    title: '문의 삭제',
    content: '해당 문의를 삭제하시겠습니까?',
    okText: '확인',
    okType: 'danger',
    cancelText: '취소',
    async onOk() {
      console.log(id);
      await deleteBoard(id);
      router.go(0);
    },
    onCancel() {
      console.log('Cancel');
    },
  });
};

onMounted(async () => {
  await getList();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, {
        class: "chevron",
        icon: "fa-solid fa-bars",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showMobileMenu()))
      }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(boardList.value, (board) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: board.id
            }, [
              _createElementVNode("td", _hoisted_8, _toDisplayString(board.id), 1),
              _createElementVNode("td", _hoisted_9, _toDisplayString(board.name), 1),
              _createElementVNode("td", _hoisted_10, _toDisplayString(board.email), 1),
              _createElementVNode("td", _hoisted_11, _toDisplayString(board.message), 1),
              _createElementVNode("td", _hoisted_12, [
                _createElementVNode("span", {
                  class: "button_red",
                  onClick: ($event: any) => (deleteAsk(board.id))
                }, "✕", 8, _hoisted_13)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})